module.exports = __webpack_public_path__ + "media/images/front/ad_modal/close-367d019e663e3a297993cb85521bf615.svg";